var Backbone = require('backbone');


var RoleModel = Backbone.Model.extend({
    defaults: {
        id: undefined,
        templateName: undefined,
        templateType: undefined,
        canRead: false,
        canReadAll: false,
        canReadFor: false,
        canWrite: false,
        canWriteFor: false,
        canWriteAll: false,
        canDelete: false,
        canSign: false,
        canSignAll: false,
        canUploadFor: false,
        canChangeReviewer: false
    },

    urlRoot: '/api/permission/template'

});


module.exports = RoleModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/role-model.js
// module id = 246
// module chunks = 0